interface SalesLine {
  quantity: number;
  unitPrice: number;
  discountPercent: number;
  taxRate: number;
}

// Calculate on every form render: react-hook-form can mutate the items array
// in place, so memoizing by its identity leaves discount/price edits stale.
export function calculateSalesTotals(items: SalesLine[] = [], globalDiscountPercent = 0) {
  let subtotal = 0;
  let taxAmount = 0;
  const discountFactor = 1 - (globalDiscountPercent || 0) / 100;
  for (const item of items) {
    const lineSubtotal = (item.quantity || 0) * (item.unitPrice || 0)
      * (1 - (item.discountPercent || 0) / 100);
    subtotal += lineSubtotal;
    taxAmount += lineSubtotal * discountFactor * ((item.taxRate || 0) / 100);
  }
  const discountAmount = subtotal * ((globalDiscountPercent || 0) / 100);
  return { subtotal, discountAmount, taxAmount, total: subtotal - discountAmount + taxAmount };
}
